export class LobbyEntryGridGroup {
    TenantId: number = 0;
    LocationId: number = 0;
    Page: number = 0;
    PageSize: number = 0;
    SortColumn: string = '';
    SortDirection: string = '';
    SearchText: string = '';
    LanguageKey: string = '';
    UserRequested: number | null = null;
    PreferredLanguageId: number = 1;
}
